import React from 'react';

import {assert} from 'Asserts';

import {BaseSeedDataConfig, SeedDataConfigType} from './SeedDataTypes';

export type ExampleSeedDataConfig = BaseSeedDataConfig<
  SeedDataConfigType.EXAMPLE_SEED_DATA,
  {exampleNonEmptyText: string}
>;

export function validateExampleSeedDataConfig(config: ExampleSeedDataConfig): boolean {
  return config.data.exampleNonEmptyText.length > 0;
}

/**
 * This is an example component for configuring seed data.
 *
 * It is not intended to be used in production.
 *
 * @package
 */
export function ExampleSeedDataConfigEditor(props: {
  value: ExampleSeedDataConfig;
  onChange: (value: ExampleSeedDataConfig) => void;
}): JSX.Element {
  assert(
    global.__NODE_TESTING__ || Boolean(process.env.STORYBOOK),
    'ExampleSeedDataConfigEditor is only supported in tests / storybook as an example.'
  );
  return (
    <>
      <label>Non-empty example text</label>
      <input
        type="text"
        value={props.value.data.exampleNonEmptyText}
        onChange={(e) => {
          props.onChange({
            type: SeedDataConfigType.EXAMPLE_SEED_DATA,
            data: {exampleNonEmptyText: e.target.value},
          });
        }}
      />
    </>
  );
}
